import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { getEquipmentList } from '../../actions/equipment';
import { getMatchParams, isToday, isRangeChanged } from '../../helpers/common';
import { DataTable, CardContainer, Heading5, Icon, Modal } from '../widgets';
import EquipmentForm from './EquipmentForm';
import EquipmentItem from './EquipmentItem';

const EquipmentList = ({ match }) => {
    const dispatch = useDispatch();
    const [farmId, setFarmId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const isRequesting = useSelector((state) => state.equipment.isRequesting);
    const equipmentList = useSelector((state) => state.equipment.equipmentList);
    const searchParams = useSelector((state) => state.analyze.searchParams);
    const search = {
        rangeId: searchParams.rangeId,
        range: searchParams.range,
        customRange: searchParams.customRange,
        custom: searchParams.custom,
    };

    // On mount
    useEffect(() => {
        const { farmId } = getMatchParams(match.params);
        setFarmId(farmId);
        dispatch(getEquipmentList({ farmId }));
    }, [match.params, dispatch]);

    // On search range change
    const prevSearchRef = React.useRef(search);
    useEffect(() => {
        if (isRangeChanged(prevSearchRef.current, search)) {
            dispatch(getEquipmentList({ farmId }));
        }
        prevSearchRef.current = search;
    }, [search, farmId, dispatch]);

    return (
        <CardContainer lg={12} md={12}>
            <Card className="card-list equipment-list">
                <Card.Header>
                    <Card.Title>
                        <Heading5>Equipment List</Heading5>
                        {isToday(search.range) && (
                            <Button
                                variant="success"
                                size="sm"
                                title="Add Equipment"
                                className="float-right"
                                onClick={() => setShowModal(true)}
                            >
                                <Icon className="fa fa-plus" /> Add Equipment
                            </Button>
                        )}
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <DataTable>
                                <DataTable.Header>
                                    <DataTable.Row>
                                        <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                                        <DataTable.Cell>Name</DataTable.Cell>
                                        <DataTable.Cell>Equipment Type</DataTable.Cell>
                                        <DataTable.Cell>Category</DataTable.Cell>
                                        <DataTable.Cell>Make</DataTable.Cell>
                                        <DataTable.Cell>Model</DataTable.Cell>
                                        <DataTable.Cell>Year</DataTable.Cell>
                                        <DataTable.Cell>Serial Number</DataTable.Cell>
                                        {isToday(search.range) && (
                                            <DataTable.Cell style={{ width: "64px" }}>Action</DataTable.Cell>
                                        )}
                                    </DataTable.Row>
                                </DataTable.Header>
                                <DataTable.Body>
                                    {equipmentList.map((e, i) => (
                                        <EquipmentItem
                                            key={i}
                                            index={i}
                                            equipment={e}
                                            farmId={farmId}
                                            search={search}
                                        />
                                    ))}
                                </DataTable.Body>
                            </DataTable>
                            {isRequesting ? (
                                <DataTable.Loading />
                            ) : (
                                equipmentList.length === 0 && <DataTable.RecordsNotFound />
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {showModal && (
                <Modal show={true} backdrop="static" className="equipment-modal-form">
                    <EquipmentForm
                        onHide={() => setShowModal(false)}
                        farmId={farmId}
                    />
                </Modal>
            )}
        </CardContainer>
    );
};

export default EquipmentList;